import { RemakeSurgicalOrder } from 'domain/usecases/surgical-order/remake-surgical-order'
import { SurgicalOrderRepository } from 'repository/interfaces/surgical-order-repository'

export class RemoteRemakeSurgicalOrder implements RemakeSurgicalOrder {
  constructor(
    private readonly surgicalOrderRepository: SurgicalOrderRepository
  ) {}

  update(
    params: RemakeSurgicalOrder.Params
  ): Promise<RemakeSurgicalOrder.Model> {
    return this.surgicalOrderRepository.remakeSurgicalOrder(params)
  }
}
